<app-header [isStudent]="false"></app-header>
<div class="search-container">
  <div class="title-header">Similarity Reports</div>
  <mat-form-field appearance="outline" class="studentIdFormField">
    <mat-label>Student Id</mat-label>
    <input matInput type="text" [(ngModel)]="studentId">
  </mat-form-field>
  <mat-form-field appearance="outline" class="filterByFormField">
    <mat-label>Select Filter</mat-label>
    <mat-select [(value)]="filterBy">
      <mat-option>None</mat-option>
      <mat-option value="assessmentCode">Assessment Code</mat-option>
      <mat-option value="submissionId">Submission ID</mat-option>
      <mat-option value="taskId">Task ID</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="filterValueFormField">
    <mat-label>Value</mat-label>
    <input matInput type="text" [(ngModel)]="filterValue">
  </mat-form-field>
  <button class="searchButton" mat-flat-button color="primary" (click)="searchClick()" [disabled]="!studentId">SEARCH</button>
</div>

<div class="resultsContainer">
  <div class="tableTitle"><span class="font-weight-600">Submissions</span> - {{currentStudentId}}</div>
  <div class="noResults" *ngIf="pagedSubmissionList.length == 0">No Submissions Found</div>
  <table mat-table matSort (matSortChange)="sortData($event)" matSortActive="dateSubmitted" matSortDirection="desc" multiTemplateDataRows *ngIf="pagedSubmissionList.length > 0" [dataSource]="pagedSubmissionList" class="submissionTable">

    <ng-container matColumnDef="dateSubmitted">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dateSubmitted"> SUBMISSION DATE </th>
      <td mat-cell *matCellDef="let element"> {{element.dateSubmitted | date:'dd MMM y'}} </td>
    </ng-container>
  
    <ng-container matColumnDef="taskName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="taskName"> TASK NAME </th>
      <td mat-cell *matCellDef="let element"> {{element.taskName}} </td>
    </ng-container>
  
    <ng-container matColumnDef="attempt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="attempt"> ATTEMPT </th>
      <td mat-cell *matCellDef="let element"> {{element.attempt}} </td>
    </ng-container>
  
    <ng-container matColumnDef="assessmentCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="assessmentCode"> ASSESSMENT CODE </th>
      <td mat-cell *matCellDef="let element"> {{element.assessmentCode}} </td>
    </ng-container>
  
    <ng-container matColumnDef="files">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="files"> FILES </th>
      <td mat-cell *matCellDef="let element"> {{element.attachments ? element.attachments.length : 0}} </td>
    </ng-container>
  
    <ng-container matColumnDef="submissionId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="submissionId"> SUBMISSION ID </th>
      <td mat-cell *matCellDef="let element"> {{element.submissionId}} </td>
    </ng-container>
  
    <ng-container matColumnDef="taskId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="taskId"> TASK ID </th>
      <td mat-cell *matCellDef="let element"> {{element.taskId}} </td>
    </ng-container>

    <ng-container matColumnDef="expanded">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon [ngClass]="{
          rotatedArrow: expandedElement === element,
          normalArrow: expandedElement !== element
        }">keyboard_arrow_down</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="emptyCol">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"></td>
    </ng-container>
  
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" >
        <div class="expanded-row-detail"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="expandedContent">
            <div class="fileItem" *ngFor="let file of element.attachments">{{file.title}}</div>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="similarityButton">
      <td mat-cell *matCellDef="let element">
        <div class="expanded-row-detail"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="expandedContent">
            <div class="fileItem" *ngFor="let file of element.attachments">
              <span *ngIf="file.similarityScore != null" class="similarityReportButton" (click)="navigateToScan(file.studentId, file.attachmentId)" onkeydown="navigateToScan(file.studentId, file.attachmentId)">SIMILARITY REPORT</span>
              <span *ngIf="file.similarityScore == null && file.status !== StatusEnum.processing && file.status !== StatusEnum.error && !file.excludedType" class="initiateScanButton" (click)="initiateScan(element, file)" onkeydown="initiateScan(file.studentId, file.attachmentId)">INITIATE SCAN</span>
              <span *ngIf="file.status === StatusEnum.error" class="errorMessage" (click)="initiateScan(element, file)" onkeydown="initiateScan(file.studentId, file.attachmentId)">RETRY SCAN</span>
              <span *ngIf="file.status === StatusEnum.processing" class="pendingMessage">PROCESSING...</span>
              <span *ngIf="file.excludedType" class="excludedType">FILE TYPE NOT SUPPORTED</span>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === row"
    (click)="expandedClick(row)" onkeydown="expandedElement = expandedElement === row ? null : row"></tr>
    <tr mat-row *matRowDef="let row; columns: ['emptyCol', 'expandedDetail', 'similarityButton']" class="example-detail-row"></tr>
  </table>

  <mat-paginator #paginator
    class="paginator"
    (page)="handlePageEvent($event)"
    [length]="length"
    [pageSize]="pageSize"
    [disabled]="disabled"
    [showFirstLastButtons]="showFirstLastButtons"
    [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
    [hidePageSize]="hidePageSize"
    [pageIndex]="pageIndex"
    aria-label="Select page">
  </mat-paginator>
</div>


